import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { BASE_HEADERS } from '../../constants/api'
import { DocusignAccount, DocusignUserInfo } from '../../types/docusignUser'
import { createDocusignRequest } from '../../../src/utils/docusign-api'
interface DocusignAuthState {
  user: DocusignUserInfo | null
  defaultAccount: DocusignAccount | null
}

const initialState: DocusignAuthState = {
  user: null,
  defaultAccount: null,
}

export const fetchUserInfo = createAsyncThunk('docusign-auth/fetchUserInfo', async () => {
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_DOCUSIGN_AUTH_API_URL}/oauth/userinfo`, {
      headers: {
        ...BASE_HEADERS,
        Authorization: `Bearer ${localStorage.getItem('DOCUSIGN_ACCESS_TOKEN')}`,
      },
    })
    const defaultAccount = data?.accounts.find((acc) => acc.is_default)
    if (defaultAccount) {
      const userSettings = await createDocusignRequest(defaultAccount).get('/settings')
      data['accountDateTimeFormat'] = (userSettings?.data['accountDateTimeFormat'] || '')
        .replaceAll('y', 'Y')
        .replaceAll('d', 'D')
    }
    return data
  } catch (error) {
    window.location.href = `${process.env.REACT_APP_DOCUSIGN_AUTH_API_URL}/oauth/auth?client_id=${process.env.REACT_APP_DOCUSIGN_INTEGRATION_KEY}&response_type=token&redirect_uri=${process.env.REACT_APP_DOCUSIGN_REDIRECT_URL}&scope=signature&prompt=consent`
  }
})

export const docusignAuthSlice = createSlice({
  name: 'docusignAuth',
  initialState,
  reducers: {
    //
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchUserInfo.fulfilled,
      (
        state,
        action: {
          payload: DocusignUserInfo
        },
      ) => {
        const defaultAccount = action.payload.accounts.find((acc) => acc.is_default)

        if (defaultAccount) {
          state.defaultAccount = defaultAccount
          state.user = action.payload
        }
      },
    )
    builder.addCase(fetchUserInfo.rejected, (state) => {
      state.user = null
      state.defaultAccount = null
    })
  },
})

// export const {} = docusignAuthSlice.actions
export default docusignAuthSlice.reducer
